

import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';


export  class PersonIdentityDO{
    public id:Number=null;

	public identityTypeCd:String=null;

	public identityNum:String=null;

	public getId():Number {
		return this.id;
	}

	public setId(id:Number) {
		this.id = id;
	}

	public getIdentityTypeCd():String {
		return this.identityTypeCd;
	}

	public setIdentityTypeCd(identityTypeCd:String){
		this.identityTypeCd = identityTypeCd;
	}

	public getIdentityNum():String {
		return this.identityNum;
	}

	public setIdentityNum(identityNum:String) {
		this.identityNum = identityNum;
	}


}